export const IMAGES_ASSETS_URL = "https://assets.thdstatic.com/images/v1";
export const PAYMENTS_PATH = "/myaccount/payments/";
